import { render, staticRenderFns } from "./IncomeDocumentsPage.vue?vue&type=template&id=fa22693e&scoped=true"
import script from "./IncomeDocumentsPage.vue?vue&type=script&lang=js"
export * from "./IncomeDocumentsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa22693e",
  null
  
)

export default component.exports